/**
 * Title for input helper for forgot password
 */
export enum AgreementLabel {
  AgentPolicy = 'プライバシーポリシー',
  AgentAgreement = '利用規約',
  CandidatePolicy = 'Privacy Policy',
  CandidateAgreement = 'Terms and Conditions',
}
